
$(document).ready(function () {
	$('.galleryWrapper').each(function () {
		$(this).lightGallery();
	});

	$('.albumControl').click(function () {
		let albumId = $(this).data('album-id');
		let thisHasClassActive = $(this).hasClass('active');

		$('.albumControl, .albumSection').removeClass('active');

		if (!thisHasClassActive) {
			$('.albumControl[data-album-id=' + albumId + '], #album_' + albumId).addClass('active');
		}
	});
});
